import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { fetchQuestionnaireBySubjectID } from "../../../services/Questionnaire/questionnaireEndpoint.js";
import QuestionnaireTable from "./QuestionnaireTable.jsx";

export default function QuestionnaireTableComponent({ selectedUser }) {
  const [questionnaireData, setQuestionnaireData] = useState([]);
  const [loadingAvailableQuestionnaires, setLoadingAvailableQuestionnaires] =
    useState(false);

  const { t } = useTranslation("questionnaires");
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoadingAvailableQuestionnaires(true);
        await fetchQuestionnaireBySubjectID(selectedUser, setQuestionnaireData);
      } catch (error) {
        // console.log(
        //   "Error when fetching questionnaire data in questionnaireTableComponent:",
        //   error
        // );
      } finally {
        setLoadingAvailableQuestionnaires(false);
      }
    };
    fetchData();
  }, [selectedUser]);

  const codeNameDate = Array.from(
    new Set(
      questionnaireData.map((item) =>
        JSON.stringify({
          date: item.date,
          codeName: item.questionnaireCodename,
        })
      )
    )
  )
    .map((str, index) => ({ ...JSON.parse(str), id: index }))
    .sort();

  // console.log("codeNameDate", codeNameDate);

  return (
    <Box
      sx={{
        marginTop: "30px",
      }}
    >
      <Typography
        sx={{
          marginLeft: {
            sm: "unset",
            md: "unset",
          },
          marginTop: "20px",
          marginBottom: {
            xs: "20px",
            sm: "20px",
            md: "20px",
            xl: "40px",
          },
          textAlign: "center",
        }}
        variant="h5"
      >
        {t("pageTitle")}
      </Typography>
      <QuestionnaireTable
        questionnaireCodeNameDate={codeNameDate}
        selectedUser={selectedUser}
        loadingAvailableQuestionnaires={loadingAvailableQuestionnaires}
      />
    </Box>
  );
}
